import { IconButton } from '@mui/material';

import {
  SideNavigationMode,
  SideNavigationState,
  useSideNavigationModeContext,
} from './context.ts';

import { ReactComponent as CollapseIcon } from './assets/collapse-icon.svg';
import { ReactComponent as ExpandIcon } from './assets/expand-icon.svg';

export function SidebarNavigationButton() {
  const {
    setSideNavigationModeToFixed,
    setSideNavigationModeToOverlayOnHover,
    sideNavigationMode,
    sideNavigationState,
  } = useSideNavigationModeContext();

  return (
    <IconButton
      aria-label={
        sideNavigationMode === SideNavigationMode.OverlayOnHover
          ? 'Make navigation fixed'
          : 'Make navigation collapsed'
      }
      aria-expanded={sideNavigationState === SideNavigationState.Expanded}
      onClick={() => {
        if (sideNavigationMode === SideNavigationMode.Fixed) {
          setSideNavigationModeToOverlayOnHover();
        } else {
          setSideNavigationModeToFixed();
        }
      }}
      tabIndex={sideNavigationState === SideNavigationState.Collapsed ? -1 : 0}
      color="inherit"
    >
      {sideNavigationMode === SideNavigationMode.OverlayOnHover ? (
        <ExpandIcon width={22} height={22} />
      ) : (
        <CollapseIcon width={22} height={22} />
      )}
    </IconButton>
  );
}
